import React, {FC} from "react";
import {Card, CardContent, CardHeader} from "framework7-react";
import './ProfileCard.css'
interface PCProps {
    data?: any
    operatorName?: string
    atag: string
    operatorData?: {
        company_name?: string,
        currency?: string,
        site?: string
    }
}

export const ProfileCard: FC<PCProps> = ({data,atag, operatorName, operatorData}) => {
    return (
        <Card>
            <CardHeader className="data-profile-card">
                <div>
                    Hello, {data?.email} <br/>
                    <span className='bold'>Operator: {operatorName}</span>
                </div>
                <div>
                    {atag}
                </div>
            </CardHeader>
            <CardContent>
                <div className='balance'>
                    1.250,00 {operatorData?.currency}
                </div>
            </CardContent>
        </Card>
    )
};